import { gridsNames } from '../../enums/gridsNames';
import * as gridActionsHelper from 'infrastructure/js/components/Grid/Utils/gridActionsHelper';
import {getShipmentLots} from '../../services/Shipments/shipmentsService';

const gridActions = gridActionsHelper.getGridActions(gridsNames.SHIPMENT_LOTS, _fetchDataAction, _convertToRowData);

function _fetchDataAction(query) {
  return function (dispatch, getState) {
    const shipmentId = getState().shipmentPage.get('shipmentId');
    return getShipmentLots(shipmentId, query);
  };
}

function _convertToRowData(rows, serverTimeSeconds) {
  let items = rows.map((obj) => {
    return obj;
  });
  return items;
}

export let actionTypes = gridActions.actionTypes, api = gridActions.apiActions, jsxActions = gridActions.jsxActions;
